import { useSearchParamKey } from "../base/useSearchParamKey";

export const useEventDetailsModal = () => useSearchParamKey("event");
